export default "__VITE_ASSET__DcbmBf31__"